import { siteInit } from "./site-init";

export function setup() {
  siteInit();
}
